import { Bound } from "lib/@components/binding/Bound"
import { useState } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { createComparableTailoredTask } from "./lib/create-comparable-tailored-task"
import { useOptimisticTailoringAudit } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/hooks/use-optimistic-tailoring-audit"

export function TailoredTabTaskAudit({ children }) {
    const [justification, setJustification] = useState(null)
    const [rejection, setRejection] = useState(null)
    const { tailoredAudits, originalTaskId, originalValues, tailoredValues, title } = useBoundContext()

    const [audit, setTailoringAudit] = useOptimisticTailoringAudit(tailoredAudits?.[originalTaskId])
    const task = { isHeader: false }

    const tailoredTask = createComparableTailoredTask(originalValues, tailoredValues)
    const originalTask = { ...originalValues, id: originalTaskId, title }

    return (
        <Bound
            task={task}
            taskTailored={true}
            tailoringAudit={audit}
            setTailoringAudit={setTailoringAudit}
            justification={justification}
            setJustification={setJustification}
            originalTask={originalTask}
            tailoredTask={tailoredTask}
            rejection={rejection}
            setRejection={setRejection}
        >
            {children}
        </Bound>
    )
}
